import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros';
import { idEstadoRebate, switchCardRebate } from '../../../helper/rebateHelper';
import '../Styles/Rebates.css';

export default class RebateListItem extends Component {
  render = () => {
    const {
      idRebate,
      idPublicacion,
      descripcionSeller,
      imagen,
      titulo,
      estadoRebate,
      skuSeller,
      skuMarket,
      precioLista,
      fechaInicio,
      fechaVencimiento,
      porcentajeTotalDescuento,
      aCargoMegatone,
      porcentajeMegatone,
      aCargoSeller,
      porcentajeSeller,
      unidades,
      unidadesRestantes,
      precioFinal,
      tipoPublicacion,
      userType
    } = this.props;

    const btnEliminar = {
      style: "background-rojo-megatone",
      action: () => this.props.deleteRebate(idRebate),
      descripcion: "Eliminar Rebate"
    };

    const btnVerDetalle = {
      style: "btn-grey",
      action: () => this.props.onPublicacion(idPublicacion),
      descripcion: "Ver Detalle"
    };

    const btnAprobar = {
      style: "btn-green",
      action: () => this.props.handleEstadoRebate(idRebate, idEstadoRebate.aprobado),
      descripcion: <i className="mdi mdi-check" />
    };

    const btnRechazar = {
      style: "background-rojo-megatone",
      action: () => this.props.handleEstadoRebate(idRebate, idEstadoRebate.rechazado),
      descripcion: <i className="mdi mdi-close" />
    };

    let btn1;
    let btn2;

    switch (estadoRebate) {
      case "Activo":
        btn1 = { ...btnRechazar, descripcion: "Dar de baja" };
        btn2 = (btnVerDetalle);
        break;
      case "En revision":
        if (!userType.isSellerAdmin) {
          btn1 = (btnEliminar);
          btn2 = (btnVerDetalle);
        } else {
          btn1 = (btnAprobar);
          btn2 = (btnRechazar);
        }
        break;
      case "Pendiente":
        if (userType.isCategory) {
          btn1 = (btnEliminar);
          btn2 = (btnVerDetalle);
        } else {
          btn1 = (btnAprobar);
          btn2 = (btnRechazar);
        }
        break;
      case "Finalizado":
      case "Rechazado":
      case "Eliminado":
      case null:
        btn1 = [];
        btn2 = [];
        break;
      default:
        return estadoRebate
    }

    const isFechaNull = fechaInicio === null || fechaVencimiento === null;
    const isRebateFinalizado = estadoRebate === (null || "Finalizado" || "Rechazado" || "Eliminado");
    const { title, color } = switchCardRebate(estadoRebate); 

    return (
      <div className="list-group-item hover-background-color bg-white border border-3 border-light">
        <div className="row p-2 align-items-center">

          <div className="col-8 col-md-1 text-center text-break">
            <div className="displayInlineTable">
              <h6 className="font-weight-bold d-block">{descripcionSeller}</h6>
              <span className="font-size-072rem d-block">{idPublicacion}</span>
            </div>
          </div>

          <div className="col-4 col-md-1 text-center">
            <img className="mw-100px" alt={titulo?.substring(0, 10) + "..."} src={imagen} />
          </div>

          <div className="col-12 col-md-10">
            <div className="row px-1 justify-content-evenly align-items-center">

              <div className="col-12 col-md-5">
                <h6 className="box-title m-b-5 font-weight-bold text-break">{titulo}</h6>
                <small className="d-block mt-1">SKU Seller: {skuSeller} | SKU Market: {skuMarket}</small>
                <small className="d-block mt-1"><b>Tipo publicación: </b>{tipoPublicacion.descripcion}</small>
                <div className="d-block mt-1">
                  <div className="d-inline d-sm-block d-lg-inline">
                    <small><b>Precio Lista: </b></small>
                    <h6 className="font-weight-bold box-title m-b-0 d-inline">
                      ${formatoDecimal(precioLista)}
                    </h6>
                  </div>
                </div>
              </div>

              <div className={`card-rebate tab-pane p-1 active col-12 col-md-6 top-color-${color}`}>
                <div className="container">
                  <div className="row" style={{ minHeight: "9rem" }}>

                    <h6 className={`mt-1 mb-0 color-${color}-megatone`}>{title}</h6>

                    <div className="col-12 my-1">
                      <div className="row align-items-center">

                        <div className="col-12" hidden={isFechaNull}>
                          <small className="font-size-072rem">
                            {fechaInicio?.substr(0, 10)} al {fechaVencimiento?.substr(0, 10)}
                          </small>
                        </div>

                        <div className="col-12">
                          <div className="row align-items-center justify-content-between">

                            <div className="col-12 col-md-7">
                              <div className="row align-items-center">

                                <div className="col-auto p-2 pe-1">
                                  <h5 className="color-rojo-megatone d-inline">
                                    <strong>{porcentajeTotalDescuento}% OFF</strong>
                                  </h5>
                                </div>

                                <div className="col-7 p-0 ps-1 border-2 border-start">
                                  <div className="d-block">
                                    <small className="color-rojo-megatone d-inline">
                                      <strong>{porcentajeMegatone}% </strong>
                                    </small>
                                    <small>${formatoDecimal(aCargoMegatone)}</small>
                                    <small className="d-block font-size-072rem"> a cargo de MegaMarket</small>
                                  </div>

                                  <div className="d-block">
                                    <small className="color-rojo-megatone d-inline">
                                      <strong>{porcentajeSeller}% </strong>
                                    </small>
                                    <small>${formatoDecimal(aCargoSeller)}</small>
                                    <small className="d-block font-size-072rem"> a cargo de seller</small>
                                  </div>
                                </div>

                              </div>
                            </div>

                            <div className="col-12 col-md-4" hidden={isRebateFinalizado}>
                              <div className="row justify-content-center justify-content-lg-start">

                                <div className="col-10 d-flex flex-column text-center">
                                  <button className={`btn btn-sm ${btn1.style} my-2`} onClick={btn1.action}>
                                    {btn1.descripcion}
                                  </button>
                                </div>

                                <div className="col-10 d-flex flex-column text-center">
                                  <button className={`btn btn-sm ${btn2.style}`} onClick={btn2.action}>
                                    {btn2.descripcion}
                                  </button>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>

                    {isRebateFinalizado ?
                      <div className="row">
                        <div className="col-auto">
                          <div className="d-block">
                            <small className="color-rojo-megatone">
                              <strong>Precio Rebate: </strong>
                            </small>
                            <small>${formatoDecimal(precioFinal)}</small>
                          </div>
                        </div>
                        <div className="col-auto">
                          <small><strong>Unidades vendidas: </strong>{unidades}</small>
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col-auto">
                          <div className="d-block">
                            <small className="color-rojo-megatone">
                              <strong>Precio Final: </strong>
                            </small>
                            <small>${formatoDecimal(precioFinal)}</small>
                          </div>
                          <small className="ms-1 font-size-072rem">Precio publicado</small>
                        </div>
                        <div className="col-auto" hidden={!isFechaNull}>
                          <small><strong>Unidades: </strong>{unidadesRestantes}</small>
                        </div>
                      </div>
                    }

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}